'use strict';

app.factory('DashboardDataServiceLV', function ($http, $state, $rootScope, $stateParams, $q, $interval,  ApiService) {
    return {
        dataProvider: dataProvider,
        getTileLayout: getTileLayout,
        getData: getData,
        goto: goto,
    }

    function dataProvider() {
        return 'LV';
    }

    function goto(tile, item) {
        var params = {};
        params.z = $rootScope.DefaultGlobalZoneId;
        switch (tile.title) {
            case 'Mise à jour':
                params.name = item.name;
                params.value = item.value;
                params.image = item.image;
                params.z = 28;
                $state.go('app.list.set', params);
                break;
            case 'Production':
                var citysearch ='';
                if ($stateParams.z) 
                    params.z = $stateParams.z;
                citysearch = "|cityid-" + item.custom[3];
                params.search = "statusid-" + item.custom[0] + "|lang-" + item.custom[1] + citysearch;
                $state.go('app.list.place', params);
                break;

            case 'Repartitiondadressesparrubrique':
                var citysearch = '';
                if ($stateParams.z) 
                    params.z = $stateParams.z;
                citysearch = "|cityid-" + item.custom[4];
                params.search = "rubric-" + item.custom[1] + "|statusid-" + item.custom[2] + "|lang-" + $rootScope.LangForWork + citysearch;
                $state.go('app.list.place', params);
                break;

            case 'DernieresAdresses':
                if ($stateParams.z) {
                    params.z = $stateParams.z;
                }
                else
                    params.z = item.custom[3];
                params.id = item.value;
                params.lang = $rootScope.LangForWork;
                $state.go('app.consultation.view', params);
                break;

            case 'Datesimportantes':
               
                params.z = item;
                params.lang = $rootScope.LangForWork;
                $state.go('app.list.place', params);
                break;
            default:
                console.log("State not found for tile: " + tile.title);
                break;
        }

    }

    function getTileLayout() {
        var tiles = [
            {
                title: 'Zones',
                type: 'counter',
                template: '',
                width: 1, height: 1,
                dataSource: '/api/dashboard/getdata',
                interval: 86400000,
                value: [
                ],
            },

            {
                title: 'Production',
                type: 'table',
                template: '2',
                width: 1, height: 1,
                dataSource: '/api/dashboard/getdata',
                interval:86400000,
                value: [
                ],
            },
           
            {
                title: 'Miseajour',
                type: 'table',
                template: '1',
                width: 1, height: 1,
                dataSource: '/api/dashboard/getdata',
                interval: 86400000,
                value: [
                ],
            },
           {
               title: 'Repartitiondadressesparrubrique',
               type: 'chartdonut',
               template: '',
               image: '/www/assets/img/favicons/mstile-150x150.png',
               width: 1, height: 2,
               dataSource: '/api/dashboard/getdata',
               interval: 86400000

           },

 {
     title: 'Placeholder',
     type: 'placeholder',
     template: '',
     width: 1, height: 1,
     dataSource: '/api/dashboard/getdata',
     interval: 86400000,
     value: '100',
     label: 'Placeholder',
     image: 'fondation_louis-vuitton_new.png'
 },


 {
     title: 'Datesimportantes',
     type: 'table',
     template: '3',
     width: 1, height: 1,
     dataSource: '/api/dashboard/getdata',
     interval: 86400000

 },
           
             
            {
                title: 'DernieresAdresses',
                type: 'slide',
                template: '',
                width: 1, height: 1,
                dataSource: '/api/dashboard/getdata',
                interval: 86400000,
                value: [
                ],
            }
       

        ];

        return $q.when(tiles);
    }

    function getData(tile) {
       
        
        var custom = getcustomparam();//{"zoneId":"28"};
        return ApiService.getsilent(tile.dataSource + '?title=' + tile.title + '&lang=' + $rootScope.LangForWork + "&custom=" + JSON.stringify(custom)).then(
            function (response) {
                return response.data;
            });
    }

    function getcustomparam() {
        var c = {};
        if ($stateParams.z) {
            c["zoneId"] = $stateParams.z;
        }
        return c;
    }
});
